import hall_bg from'../images/hall_bg.png'
import classroomTables_bg from'../images/classroomTables_bg.png'
import scene_greeting from'../images/scene_greeting.png'
import classroomMain_bg from'../images/classroomMain_bg.png'
import classroomMainCut_bg from'../images/classroomMainCut_bg.png'
import classroomMainCut_bg_presentation0 from'../images/classroomMainCut_bg_presentation0.png'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import classroomMainCut_bg_presentation3 from'../images/classroomMainCut_bg_presentation3.png'
import classroomMainCut_bg_presentation4 from'../images/classroomMainCut_bg_presentation4.png'
import classroomMainCut_bg_presentation5 from'../images/classroomMainCut_bg_presentation5.png'
import classroomMainCut_bg_presentation6 from'../images/classroomMainCut_bg_presentation6.png'
import stacyShowingPussy from'../images/stacyShowingPussy.png'
import ryderTakingOffJumper from'../images/ryderTakingOffJumper.png'
import ryderBendingOver from'../images/ryderBendingOver.png'
import ryderBendingOver2 from'../images/ryderBendingOver2.png'
import ryderBendingOver3 from'../images/ryderBendingOver3.png'
import ryderBendingOver4 from'../images/ryderBendingOver4.gif'
import ryderCloserLook from'../images/ryderCloserLook.png'
import wrongSlide_bg from'../images/wrongSlide_bg.gif'
import question1 from'../images/question1.png'
import question2 from'../images/question2.png'
import question3 from'../images/question3.png'
import question4 from'../images/question4.png'
import sheet from'../images/sheet.png'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';

const chapter1 = [
  {novel:true, background:hall_bg, startCoordinates:0,
  script:[
  {char:characters["empty"],  position:"center", coordinates: 1, speed:0.8, transitionMode:"slow",
  phrases:[
    {text:"It’s been around two weeks since I started this college"},
    {text:"So far nothing special, just a routine."},
    {text:"I’ve already made some friends"},
    {text:"Though I’ve never really been social…"},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:7, transitionMode:"slow",
  phrases:[
    {text:"Оh! Here’s one of them"},
    {text:"It’s Willie, turns out we have a lot in common."},
    {text:"Like me, he’s mostly into politics, gaming and sex lol"},
    {text:"Well… maybe I could say he’s a bit of a perv haha"},
    {text:"Actually, he was the one to make me sign up for this “sex education” minor."},
    {text:"He seems to really expect a lot from it."},
    {text:"And also Phoebe should be somewhere around here..."},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 60, speed:4, transitionMode:"slow",
  phrases:[
    {text:"Hm.. Strange"},
    {text:"I bet I saw her a minute ago..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Hey, Dick!", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 55, speed:1,
  phrases:[
    {text:"Wtf"},
    {text:"How did he got here..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Ooh I can’t wait for the class to start, dude!", emotion:characters["willie"].neutral},
    {text:"Heard they started this course as an experiment!", emotion:characters["willie"].watchingPhone},
    {text:"I guess the teacher must also be open to some experimenting…", emotion:characters["willie"].snide},
    {text:"If you know what I mean haha", emotion:characters["willie"].snide},
    {text:"I bet it’s some experienced busty milf or a round ass chick who just graduated...", emotion:characters["willie"].snide},
    {text:"...", emotion:characters["willie"].surprised},
    {text:"Don’t tell me it’s her. Jesus.", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"Are you guys waiting for… the sex- the sex intercourse, I mean the sex course?", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Yeah…", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"All right.", emotion:characters["oldLady"].neutral},
    {text:"Your teacher said that she’ll be here soon, so you can come in.", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Okay, thank you ma’am.", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"In my time young people could figure out how to make children on their own... what a generation…", emotion:characters["oldLady"].frustration},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Jesus thank God it’s not her!", emotion:characters["willie"].neutral},
    {text:"Like one Grandma at home is not enough for me..", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Wait didn’t you see the teacher on the course invitation?", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Well... I was trying to read, not look.", emotion:characters["willie"].watchingPhone},
    {text:"And I went straight to writing the letter, so...", emotion:characters["willie"].neutral},
    {text:"So, will you tell the others to come in?", emotion:characters["willie"].neutral},
    {text:"You know I’m not good with people…", emotion:characters["willie"].watchingPhone, answers:["Shout to classmates to come in.", "Yeah, I’m kind of like that, too."]},
  ]
  },

  //Shout to classmates to come in.
  {option:"Shout to classmates to come in.", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Okay, I guess I can try...", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*I work up the courage to yell*"},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Ahem", emotion:characters["dick"].neutral_right},
    {text:"Um, GUYS, WE CAN COME IN!", emotion:characters["dick"].rightYelling, achievement:achievements[0]},
    {text:"...", emotion:characters["dick"].rightTired},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*Silence*"},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"That’s what I was afraid of.", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Okay, I don’t think I can do it the second time.", emotion:characters["dick"].rightTired},
    {text:"Let’s just try to walk in, I’m sure they’ll notice and follow us.", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Shout to classmates to come in.", endOfOption:true},

  //Yeah, I’m kind of like that, too.
  {option:"Yeah, I’m kind of like that, too.", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Yeah, so am I dude", emotion:characters["dick"].rightTired},
    {text:"Let’s just try to walk in, I’m sure they’ll notice and follow us.", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Yeah, I’m kind of like that, too.", endOfOption:true,  endOfOptions:true},
  {endOfNovel:true}
]
},

{novel:true, background:classroomTables_bg, startCoordinates:100,
script:[
{char:characters["empty"],  position:"center", coordinates: 60, speed:4, transitionMode:"slow",
phrases:[
  {text:"Wow..."},
  {text:"Is it even a classroom or some kind of sex dungeon..."},
  {text:"Suddenly, I saw someone waving at me"},
]
},
{scene:true, img:scene_greeting, start:true, time:300},
{scene:true, name:characters["phoebe"].name, position:"left",
phrases:[
  {text:"Hey guys, I saved us a seat!!!"}
]},
{scene:true, name:characters["empty"].name, position:"center",
phrases:[
  {text:"Phoebe’s kinda quirky and a little… out of this world"},
  {text:"It seems like everything she does is for fun"},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Finally, you’re here!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Wow there’s so much… stuff here lol", emotion:characters["willie"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Yeah", emotion:characters["phoebe"].laughing},
  {text:"A little overwhelming", emotion:characters["phoebe"].smiling},
]
},

{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Oh, I just noticed", emotion:characters["willie"].sittingSurprised},
  {text:"Is that real?", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Hmm?", emotion:characters["phoebe"].smiling},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Your face...", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"No, it’s henna", emotion:characters["phoebe"].smiling},
  {text:"I decided to get it to protect me from bad luck", emotion:characters["phoebe"].laughing},
  {text:"My horoscope says it’s gonna be a bad day, but it’s up to me", emotion:characters["phoebe"].neutral},
  {text:"So at least I’ve done my part!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["dick"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Horoscope...", emotion:characters["dick"].sittingNeutral, answers:["Do you really believe in it?", "What does mine say?"]},
]
},

//Do you really believe in it?
  {option:"Do you really believe in it?", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Well, they haven’t let me down yet!", emotion:characters["phoebe"].laughing, achievement:achievements[1]},

  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"For me my grandmother is the best horoscope. I can always tell what my day is gonna be just by looking at her face...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },
  {option:"Do you really believe in it?", endOfOption:true},

  //What does mine say?
  {option:"What does mine say?", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Hmm, you’re a Libra, aren’t you?", emotion:characters["phoebe"].smiling},
    {text:"As far as I remember you’re gonna have a good day today!", emotion:characters["phoebe"].smiling},
    {text:"It says: it’s a good day to work with your hands, all endeavors will finish well!", emotion:characters["phoebe"].laughing},
    {text:"Were you gonna do anything with your hands today?", emotion:characters["phoebe"].smiling},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"I guess I know what you were gonna do hehe", emotion:characters["willie"].sittingSnide},
    {text:"I don’t know guys, to me my grandmother is the best horoscope. I can always tell what my day is gonna be just by looking at her face...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },

  {option:"What does mine say?", endOfOption:true, endOfOptions:true},
  //


  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ahah", emotion:characters["phoebe"].laughing},
    {text:"...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"Oh hi, didn’t expect you to be here, my lovely sister.", emotion:characters["ursula"].standingNeutral},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Same here, didn’t expect such a dumbass to stay at uni for so long...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"WHAT DID YOU JUST CALL ME?", emotion:characters["ursula"].standingAngry},
    {text:"I’LL... I’LL...", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Okay bye...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"I’m not finished with you!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Hey, cool it...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"YOU COOL IT!", emotion:characters["ursula"].standingAngry2},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"WHAT THE FUCK??", emotion:characters["phoebe"].sittingCoffeeShocked},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"What? you’ve been begging for it, haven’t you?", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["stacy"],  position:"right", coordinates: 10, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Let’s go, Ursula, she’s not worth it!", emotion:characters["stacy"].sittingNeutral},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"I’LL KICK YOUR STUPID ASS NEXT TIME!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"What a bitch...", emotion:characters["phoebe"].sittingAngry},
    {text:"Now I’m all wet...", emotion:characters["phoebe"].sittingAngry},
    {text:"Well, she had a latte, an iced one", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"How bad is it?", emotion:characters["phoebe"].sittingQuestionCoffee, answers:["Well, I’d say it adds something to your look","Not bad.. But I’d say sheer"]},
  ]
  },

  //Well, I’d say it adds something to your look
  {option:"Well, I’d say it adds something to your look", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Haha, thanks, I think so too!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"And I smell like coffee now, so that’s a plus!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {option:"Well, I’d say it adds something to your look", endOfOption:true},
  //

  //Not bad.. But I’d say sheer
  {option:"Not bad.. But I’d say sheer", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Oh, well, it’s okay, I guess!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Yeah it’s totally perfect - I mean, fine...", emotion:characters["willie"].sittingSnide},
  ]
  },
  {option:"Not bad.. But I’d say sheer", endOfOption:true, endOfOptions:true},
  //
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"I didn’t even know you had a twin sister!", emotion:characters["willie"].sittingSurprised},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Honestly, I wish I didn’t", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"So you see, it’s not a good day!", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"God, I can’t stand her. She’s always been like this.", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Always just… messing up my life", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Like - last time when I had someone over, and she...", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Ah, nevermind, forget it, let’s just change the topic!", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"I’m so excited! ", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Me too! I think I’m even sweating a little bit...", emotion:characters["willie"].sittingSweating, answers:["I can’t wait for it to start!","I’m still not sure it’s gonna be any fun..."]},
  ]
  },

  //I can’t wait for it to start!
  {option:"I can’t wait for it to start!", start:true},
  {char:characters["profryderhidden"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"I can’t either!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"I can’t wait for it to start!", endOfOption:true},

  //I’m still not sure it’s gonna be any fun...
  {option:"I’m still not sure it’s gonna be any fun...", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Oh come on, pussy is always fun!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["profryderhidden"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Couldn’t agree more!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"I’m still not sure it’s gonna be any fun...", endOfOption:true, endOfOptions:true},
  //
  {endOfNovel:true}
]
},




{novel:true, background:classroomMain_bg, startCoordinates:0,
script:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:3,
phrases:[
  {text:"All right then, let’s get started!", emotion:characters["profryder"].standingSmiling},
  {text:"My name is Ms. Ryder, I’ll be your teacher", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["willie"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"<small><i>I told ya...</small></i>", emotion:characters["willie"].sittingSnide},
  {text:"<small><i>She looks like she’s from Hogwards with this “wand”</small></i>", emotion:characters["willie"].sittingNeutral},
  {text:"<small><i>Oh I wish she’d cast some erecto patronum on me hehe</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"You can treat me as your friend", emotion:characters["profryder"].standingSmiling},
  {text:"Though please don’t forget that I’m still a professor!", emotion:characters["profryder"].standingSmiling},
  {text:"So you probably want to know more about me", emotion:characters["profryder"].standingSmiling},
  {text:"I’m a recent psychology graduate and my major was sex psychology", emotion:characters["profryder"].standingSmiling},
  {text:"Now I’m planning on getting my PhD!", emotion:characters["profryder"].standingSmiling},
  {text:"And no, not the PhD you’re thinking of, but Doctor of Philosophy!", emotion:characters["profryder"].standingLaughing},
  {text:"I’m working on my dissertation right now and I think our classes will help me get some data and a proper lecturer experience.", emotion:characters["profryder"].standingNeutral},
  {text:"However, mainly the course is designed to help you overcome your difficulties with sex and eventually become a real sex guru!", emotion:characters["profryder"].standingLaughing},
  {text:"And, last but not least, I just really wouldn’t want you to be alone with your problems", emotion:characters["profryder"].standingNeutral},
  {text:"So feel free to ask questions, I’ll do my best to satisfy your needs!", emotion:characters["profryder"].standingSmiling},
]
},

{char:characters["howard"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"GIVE US THE SEX!!!", emotion:characters["howard"].sittingNeutral},
]
},

{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"Haha, all in good time, mister!", emotion:characters["profryder"].standingLaughing},
  {text:"Also, I’d really like the atmosphere in the classroom to be friendly and welcoming for sharing and discussion", emotion:characters["profryder"].standingSmiling},
  {text:"So let’s try not to judge each other", emotion:characters["profryder"].standingSmiling},
  {text:"And we’re gonna start with anatomy!", emotion:characters["profryder"].standingSmiling},
  {text:"I think of it as a foundation", emotion:characters["profryder"].standingSmiling},
  {text:"Once we learn it, it’s easier to dive into more complex things and not hurt ourselves and our partner!", emotion:characters["profryder"].standingLaughing},
  {text:"The topic is quite extensive, but I’m giving you my own crash course with the most important parts", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:2.3, noBlur:true, destinationPoint:[-25,-15, -10,-15], appearAfterMoving:true,
phrases:[
  {text:"Okay. Who can tell me what this is?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["howard"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"VAGINA!", emotion:characters["howard"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"Ahah", emotion:characters["phoebe"].sittingLaughingCoffee},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Any other options?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["willie"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"<small><i>Pussy</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, basically, yeah, it’s a pussy", emotion:characters["profryder"].standingLaughing},
  {text:"But I’d like to hear the anatomical name", emotion:characters["profryder"].standingEyebrowsUp, answers:["Clitoris","Vulva","Labia"]},
]
},

//Clitoris
{option:"Clitoris", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, it’s definitely there, but it’s only part of what’s called the vulva", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Clitoris", endOfOption:true},
//Vulva
{option:"Vulva", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Great, that’s right! ", emotion:characters["profryder"].standingLaughing, achievement:achievements[2]},
]
},
{option:"Vulva", endOfOption:true},
//Labia
{option:"Labia", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, they take up a lot of space, but they’re just part of what’s called the vulva!", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Labia", endOfOption:true, endOfOptions:true},
//

{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"So basically, the vulva is the outer part of the female genitalia", emotion:characters["profryder"].standingSmiling},
  {text:"Now, let’s take a deeper look at what it’s made up of!", emotion:characters["profryder"].standingSmiling},
  {text:"And I’d listen carefully, ‘cause today we’re going to have a little quiz", emotion:characters["profryder"].standingSmiling},
  {text:"Plus at the end of the lesson you will also have a practical part, where this is going to be quite handy!", emotion:characters["profryder"].standingSmiling},
]
},
{endOfNovel:true},
]
},

{novel:true, background:classroomMainCut_bg_presentation0, startCoordinates:0,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:3, noBlur:true, destinationPoint:[-25,-15, -15, -15], appearAfterMoving:true,
  phrases:[
    {text:"Welcome to the delicious world of vulva!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation1, gallery:gallery[1]},
  {char:characters["profryder"],  position:"right", startCoordinates:0, coordinates: 100, speed:0.5, noBlur:true, destinationPoint:[-25,-15,-15,-15], appearAfterMoving:true,
  phrases:[
    {text:"What we usually see on the surface is called the labia majora", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"I’d kiss them all over haha!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"...", emotion:characters["profryder"].standingSurprised},
    {text:"They’re made up of regular skin and can be the same color or a little darker", emotion:characters["profryder"].standingNeutral},
    {text:"And right there they are followed by the labia minora", emotion:characters["profryder"].standingNeutral},
    {text:"They are usually pink or dark brown, depending on the color of your skin...", emotion:characters["profryder"].standingBlushed},
    {text:"Together with the outer labia, they have a protective function", emotion:characters["profryder"].standingNeutral},
    {text:"And what exactly do they protect?", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation2, gallery:gallery[2]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"This area, called the vaginal vestibule", emotion:characters["profryder"].standingNeutral},
    {text:"It includes:", emotion:characters["profryder"].standingNeutral},
    {text:"Glands, like the lesser vestibular glands, which by the way work similarly to the male prostate", emotion:characters["profryder"].standingSmiling},
    {text:"They are claimed to be the source of female ejaculation, I mean squirt, but this has not been proven so far", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Wow, I’m really learning something new!</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Well, nevertheless, more experiments are left to us! we’ll definitely have a lesson about this!", emotion:characters["profryder"].standingLaughing},
  ]
  },

  //
  {changeBG:true, img:wrongSlide_bg, gallery:gallery[3]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Whoops", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Oh yeah baby just like that!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"I apologize, this should’ve been in the... the practical part", emotion:characters["profryder"].standingBlushed},
    {text:"I guess I… shouldn’t have been doing the presentation at 2 am!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>I wonder if she made this guide herself...</small></i>", emotion:characters["willie"].sittingSnide},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 75, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Haha, I bet</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"So, umm.. Let’s return to our muttons!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation2},
  //
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Also here we see the greater vestibular glands, which perform a lubricating function during sexual arousal", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"We’ll come back to them during practice today, so please pay special attention!", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Can’t wait for practice...</small></i>", emotion:characters["willie"].sittingSnide},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Well...", emotion:characters["dick"].sittingNeutral, answers:["Well, I think theory is also important","Yeeah... I hate lectures"], warning:"This choice will significantly influence <br/> the lecture"},
  ]
  },

  //Yeeah... I hate lectures
  {option:"Yeeah... I hate lectures", start:true},
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Just a bit more of it and I’ll fall asleep...", emotion:characters["dick"].sittingSleepy},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Urethra, which we pee from", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"And...", emotion:characters["profryder"].standingDisgusted},
    {text:"?", emotion:characters["profryder"].standingDisgusted},
    {text:"Oh, Richard, I can see you are bored...", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Hmm, it’s quite hot and stuffy in here, isn’t it?", emotion:characters["profryder"].standingLaughing},
    ]
  },

  {scene:true, img:ryderTakingOffJumper, start:true, time:300, gallery:gallery[4]},
  {scene:true, name:characters["profryder"].name,  position:"center",
  phrases:[
    {text:"I'll just take off my jumper to cool down a bit..."},
  ]
  },
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"I think we should also have some fresh air coming in", emotion:characters["profryder"].standingLaughingShirt},
    {text:"I can’t let my students feel bored!", emotion:characters["profryder"].standingSmilingShirt},
    {text:"So where were we...", emotion:characters["profryder"].standingQuestionShirt},
    {text:"Oh sure, vagina!", emotion:characters["profryder"].standingLaughingShirt},
    {text:"Let me show you where it is", emotion:characters["profryder"].standingEyebrowsUpShirt},
    {text:"...", emotion:characters["profryder"].standingDroppedStick},
    ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:1, noBlur:true,
  phrases:[
    {text:"*clunk*"},
    ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Oh no!", emotion:characters["profryder"].standingDroppedSurprised},
    {text:"Look at that! I just dropped my pointer...", emotion:characters["profryder"].standingDroppedSurprised},
    {text:"I need to bend over to pick it up!", emotion:characters["profryder"].standingDroppedBlushed},
    ]
  },
  {scene:true, img:ryderBendingOver, start:true, time:800},
  {scene:true, name:characters["profryder"].name,  position:"left",
  phrases:[
    {text:"Huh?"},
    {text:"Richard! I can see what you are looking at!"},
    {text:"Well.. At least now you’re paying attention!"},
    {text:"So..."},
  ]
  },
  {scene:true, img:ryderBendingOver2, changeScene:true},
  {scene:true, name:characters["profryder"].name,  position:"left",
  phrases:[
    {text:"The vagina is up here"},
  ]
  },
  {scene:true, img:ryderBendingOver3, changeScene:true},
  {scene:true, name:characters["profryder"].name,  position:"left",
  phrases:[
    {text:"Right down my butthole"},
  ]
  },
  {scene:true, img:ryderBendingOver4, changeScene:true, gallery:gallery[5]},
  {scene:true, name:characters["profryder"].name,  position:"left", dialogCoordinates:"65vh",
  phrases:[
    {text:"Oh, and do you remember what are these juicy things called?", answers:["Labia minora","Labia majora"]},
  ]
  },
  {option:"Labia minora", start:true},
  {scene:true, img:ryderBendingOver, changeScene:true},
  {scene:true, name:characters["profryder"].name,  position:"left", dialogCoordinates:"60vh",
  phrases:[
    {text:"Oh, darling, seems like you’ll have to stay after classes..."},
    {text:"I'll be giving you a special lecture!"},
  ]
  },
  {option:"Labia minora", endOfOption:true},

  {option:"Labia majora", start:true},
  {scene:true, img:ryderBendingOver, changeScene:true},
  {scene:true, name:characters["profryder"].name,  position:"left", dialogCoordinates:"60vh",
  phrases:[
    {text:"Yes, That’s right, Richard!"},
    {text:"You're catching on so fast!"},
    {text:"You know… I DO love smart students..."},
  ]
  },
  {option:"Labia majora", endOfOption:true, endOfOptions:true, subEnd:true},
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Okaay...", emotion:characters["profryder"].standingSmilingShirt},
    {text:"Now let’s proceed with the most sensitive and exciting part of the vulva", emotion:characters["profryder"].standingSmilingShirt},
    ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation4, gallery:gallery[6]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
phrases:[
  {text:"Clitoris!", emotion:characters["profryder"].standingLaughingShirt},
  {text:"This little thing makes me... I mean girls... feel so good when it’s touched...", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Especially by", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Richard!", emotion:characters["profryder"].standingQuestionShirt},
  {text:"You just can’t stop staring at them, don’t you?", emotion:characters["profryder"].standingQuestionShirt},
  {text:"Well, okay, I guess the only way to grab your attention to the lecture is to give you a", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Closer look", emotion:characters["profryder"].standingSmilingShirt},
  ]
},
  {scene:true, img:ryderCloserLook, start:true, time:800, dialogCoordinates:"50vh", gallery:gallery[7]},
  {scene:true, name:characters["profryder"].name,  position:"center",
  phrases:[
    {text:"Well..."},
    {text:"Tell me how you like them..."},
    {text:"They are so big and soft"},
    {text:"So wet from all this heat you were giving me all the class, Richard..."},
    {text:"I can see you imagining your cock between them"},
    {text:"Sliding in and out, in and out..."},
    {text:"How can I keep going with my lecture"},
    {text:"If I want it so much too, Richard..."},
    {text:"Richard?"},
    {text:"Richard?"},
  ]
  },
  {scene:true, endOfScene:true, time:1200, endOfSceneLoadNext:true, dialogCoordinates:"60vh"},

  {changeBG:true, img:classroomMainCut_bg_presentation6, gallery:gallery[8]},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Richard, are you here?", emotion:characters["profryder"].standingQuestion, achievement:achievements[15]},
    {text:"I hope you've been listening carefully, because we are going to have a little test right now...", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"All right", emotion:characters["profryder"].standingNeutral},
    {text:"And for everyone, while I hand out the test, you can look through all the different vulvas here", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"And remember they are all unique and beautiful, there is nothing to be ashamed of", emotion:characters["profryder"].standingEyebrowsUp},
    ]
  },

  {option:"Yeeah... I hate lectures", endOfOption:true},

  //Well, I think theory is also important
  {option:"Well, I think theory is also important", start:true},
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Let’s listen!", emotion:characters["dick"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Urethra, which we pee from", emotion:characters["profryder"].standingNeutral},
    {text:"And vagina, which would take a separate lecture, so we’ll talk more about it in one of the next lessons!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Now let’s get to the fun part!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation3},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Who knows what this little thingy is?", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Don’t know what you call it but my try is the little man in the boat", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Ugh...", emotion:characters["ursula"].sittingDisgusted},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"So we usually call it clit, but the actual term is clitoris", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation4, gallery:gallery[6]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"And here it has a clitoral hood that usually covers it when unaroused", emotion:characters["profryder"].standingSmiling},
    {text:"Anybody knows what it serves for?", emotion:characters["profryder"].standingQuestion},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:1,
  phrases:[
    {text:"*Silence*"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Girls, come on, what does it make you feel like when you touch it?", emotion:characters["profryder"].standingSmiling},
    {text:"Ursula, from your motivational letter I gathered you have some experience, it would be great if you shared!", emotion:characters["profryder"].standingQuestion},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 75, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"It really depends on the situation..", emotion:characters["ursula"].sittingNeutral},
    {text:"Sometimes it might be unpleasant, even", emotion:characters["ursula"].sittingNeutral},
    {text:"But usually it makes me...", emotion:characters["ursula"].sittingNeutral},
    {text:"Kinda feel good, you know.", emotion:characters["ursula"].sittingWhatever},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Yes, this little thingy might give you both pleasure and pain..", emotion:characters["profryder"].standingNeutral},
    {text:"Depending when and how you deal with it", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"In general, the clitoris is the bundle of nerves responsible for female arousal and orgasm", emotion:characters["profryder"].standingNeutral},
    {text:"Can you imagine that just the clitoral glans has about 10 thousand nerve endings! just think of it!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"And it’s while the penis glans has only about 4 thousand!", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"AND STILL, WE ARE BETTER!", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Sure-sure, as you say, darling...", emotion:characters["profryder"].standingDisgusted},
    {text:"So no wonder why female orgasms tend to be way more intense!", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation5},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"And the pearl we see from outside is just the tip of the iceberg, this is what clitoris actually looks like!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"The legs on the sides and the bulb of the vestibule help with arousal during vaginal penetration", emotion:characters["profryder"].standingSmiling},
    {text:"So in fact all orgasms women can have are clitoral, anatomically speaking...", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"What about anal orgasm?!", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Well, we’ll dive into it in one of the next lessons", emotion:characters["profryder"].standingLaughing},
    {text:"For now, I can tell you that it’s essentially an indirect stimulation of the clitoris", emotion:characters["profryder"].standingSmiling},
    {text:"I’d also like to add that clitorises come in many different colors", emotion:characters["profryder"].standingSmiling},
    {text:"In color, size of the clitoris itself, as well as the hood", emotion:characters["profryder"].standingSmiling},
    {text:"Looking ahead, it also increases in size during arousal, this is called clitoral erection", emotion:characters["profryder"].standingSmiling},
    {text:"Well, before we get to talking about female arousal and its practice, let’s take a little quiz to test our knowledge!", emotion:characters["profryder"].standingLaughing},
  ]
  },
{changeBG:true, img:classroomMainCut_bg_presentation6, gallery:gallery[8]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Almost forgot, while I hand out the test, you can look through all the different vulvas here, and remember they are all unique and beautiful, there is nothing to be ashamed of!", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {option:"Well, I think theory is also important", endOfOption:true, endOfOptions:true},

  {char:characters["empty"],  position:"center", coordinates: 80, speed:2, transitionMode: "slow",
  phrases:[
    {text:"*Prof. Ryder started handing out the tests*"},
  ]
  },
  {endOfNovel:true}
]
},

{novel:true, background:classroomTables_bg, startCoordinates:20,
script:[
  {char:characters["ursula"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Mine is exactly like in the 3rd pic...", emotion:characters["ursula"].sittingSurprised},
  ]
  },
  {char:characters["stacy"],  position:"right", coordinates: 20, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Oh I’m not sure what mine looks like, can you check?", emotion:characters["stacy"].sittingNeutral},
  ]
  },
  {scene:true, img:stacyShowingPussy, start:true, time:800, gallery:gallery[9]},
  {scene:true, name:characters["ursula"].name,  position:"left",
  phrases:[
    {text:"Hmm, I think it looks like that 4th one..."},
  ]
  },
  {scene:true, name:characters["howard"].name,  position:"left",
  phrases:[
    {text:"In case you want some expert opinion I’d recommend you showing it to me!!!"},
  ]
  },
  {scene:true, endOfScene:true, time:100, endOfSceneLoadNext:true},
  {char:characters["stacy"],  position:"right", coordinates: 20, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Fuck off, Howard!", emotion:characters["stacy"].sittingAngry},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Dude, that was like the first time I saw a real pussy...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Wow she’s so...", emotion:characters["phoebe"].sittingSurprisedCoffee},
    {text:"Brave", emotion:characters["phoebe"].sittingSurprisedCoffee},
    {text:"Well, um... Wanna guess what mine looks like? ahah", emotion:characters["phoebe"].sittingLaughingCoffee, answers:["2","3","7"]},
  ]
  },
  //2
  {option:"2", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Hmm, well, there’s definitely something similar!", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Ahahah, I didn’t think you would actually try to guess!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Didn’t you see the sign? All vulvas are unique!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"But if you wanna know...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Well it’s hard to find something similar here...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"I’d say it looks like some kind of burger to me", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"2", endOfOption:true},

  //3
  {option:"3", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Did you say that just because you heard my freaking sister has it?", emotion:characters["phoebe"].sittingAngry, achievement:achievements[3]},
    {text:"Haahah relax I’m just messing with you!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"I didn’t think you would actually try to guess", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Didn’t you see the sign? All vulvas are unique!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"But if you wanna know...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Well it’s hard to find something similar here...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"I’d say it looks like some kind of burger to me", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"3", endOfOption:true},

  //7
  {option:"7", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Nope, but close, and I knew this girl with number 7...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Ahaha, I didn’t think you would actually try to guess!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Didn’t you see the sign? All vulvas are unique!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"But if you wanna know...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Well it’s hard to find something similar here...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"I’d say it looks like some kind of burger to me", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"7", endOfOption:true, endOfOptions:true},
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Lol, a burger?", emotion:characters["willie"].sittingSurprised},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Yeah!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"You mean like a thick juicy one with a lot of salad and stuff or...", emotion:characters["willie"].sittingSnide},
    {text:"A neat one like...", emotion:characters["willie"].sittingNeutral},
    {text:"Like a cheeseburger?", emotion:characters["willie"].sittingNeutral},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Oh, the test is about to start!", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
{endOfNovel:true}
]
},

{novel:true, background:classroomMainCut_bg_presentation6, startCoordinates:80,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true,
  phrases:[
    {text:"Before we begin, I’d like to point out a rather personal question from me, at the end of the test", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"I’m just collecting data for a study I’m doing with my colleague.", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"It won’t affect your grade of course, if you answer it or not", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"However, if you choose to answer it, it would help us a lot!", emotion:characters["profryder"].standingLaughing},
    {text:"All right everyone, you’ll have 3 minutes to complete the test, your time starts now!!", emotion:characters["profryder"].standingNeutral},
  ]
  },
  {endOfNovel:true}
]
},

{test:true, questions:[
  {question:'Name the anatomy structure marked as "?" on the picture', img: question1, answers:["Labia majora","Pubic mound","Labia minora"], answer:"a",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>It’s the first one</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>Maybe 2nd?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},

  {question:'Name the anatomy structure marked as "?" on the picture', img: question2, answers:["Clitoris","Clitoral hood","Labia minora"], answer:"b",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>It’s the second one</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>Maybe first one?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},

  {question:'Name the anatomy structure marked as "?" on the picture', img: question3, answers:["Penile glans","Greater vestibular glands","Lesser vestibular glands"], answer:"b",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>It’s greater ones</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>Looks like vagina...</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},
  {question:'Name the anatomy structure marked as "?" on the picture', img: question4, answers:["Bulb of vestibule","Clitoral hood","Crus(Legs) of clitoris"], answer:"c",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>It’s legs of clitoris!</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>Looks like clitoris...</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},

  {question:"What <i>clitoris</i> is related to..", answers:["Urination","Sexual arousal","Clitoris does not exist"], answer:"b",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>Sexual arousal of course!</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>Maybe third?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},

  {question:"All vulvas are...", answers:["Unique","Same","Juicy"], answer:"a",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>Unique</small></i>"},
        {text:"<small><i>But juicy sounds right too lol</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno...</small></i>"},
        {text:"<small><i>I’d say juicy!</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},
  {question:"What male anatomy structure <i>lesser vestibular glands</i> are similar to?", answers:["Prostate","Penile glans","Testicles"], answer:"a",
  hints: [[  {
      char:"Phoebe",  position:"left",
      phrases:[
        {text:"<small><i>I have no idea..</small></i>"},
        {text:"<small><i>Prostate?</small></i>"},
        {text:"<small><i>What is it anyway...</small></i>"},
      ]
    },
    {
      char:"Professor",  position:"right",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ],
  [  {
      char:"Willie",  position:"right",
      phrases:[
        {text:"<small><i>Oh, dude, I dunno</small></i>"},
        {text:"<small><i>The only thing I remember is that it’s connected with squirt...</small></i>"},
        {text:"<small><i>Maybe testicles?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Professor",  position:"left",
      phrases:[
        {text:"Guys, please, do not cheat!"},
        {text:"I really need to know what you got from this class.."}
      ]
    }
  ]
  ]},
  {question:"Have you ever had or fantasized about having sexual experience with a partner significantly older than you?", answers:["Yes, I fantasized","Yes, I had","No"], specialQuestion:true},
],
},
{afterTest:true, background:classroomMainCut_bg_presentation6, startCoordinates:0,
  resultAA:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
  phrases:[
    {text:"Uh-huh... uh-huh", emotion:characters["profryder"].standingLookingTest},
    {text:"Very good..", emotion:characters["profryder"].standingSmilingTest},
    {text:"Great!", emotion:characters["profryder"].standingLookingTest},
    {text:"Just Great!", emotion:characters["profryder"].standingSurprisedTest},
    {text:"You’re the only one with no mistakes at all!", emotion:characters["profryder"].standingSurprisedTest},
    {text:"You’re such a gifted student...", emotion:characters["profryder"].standingCheckingTestAroused, achievement:achievements[5]},
    {text:"That’s an ‘A+’, keep it up!!!", emotion:characters["profryder"].laughingTestAroused},
  ]
  },
],
resultA:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Uh-huh... uh-huh", emotion:characters["profryder"].standingLookingTest},
  {text:"Very good..", emotion:characters["profryder"].standingSmilingTest},
  {text:"Great!", emotion:characters["profryder"].standingLookingTest},
  {text:"You’ve only got one mistake!", emotion:characters["profryder"].standingLookingTest},
  {text:"That’s an ‘A’, keep it up!", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultB:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Uh-huh... uh-huh", emotion:characters["profryder"].standingLookingTest},
  {text:"Okay...", emotion:characters["profryder"].standingSmilingTest},
  {text:"Yep, you’ve got almost everything right!", emotion:characters["profryder"].standingLookingTest},
  {text:"There’re only 2 mistakes", emotion:characters["profryder"].standingLookingTest},
  {text:"I’ll give you a ‘B’", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultC:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Okay", emotion:characters["profryder"].standingLookingTest},
  {text:"Uh-huh", emotion:characters["profryder"].standingLookingTest},
  {text:"Not bad, but you’ve got 3 mistakes here", emotion:characters["profryder"].standingSmilingTest},
  {text:"So that’s a ‘C’ for now", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultD:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Okay", emotion:characters["profryder"].standingLookingTest},
  {text:"Uh-huh", emotion:characters["profryder"].standingNeutralTest},
  {text:"Mhm", emotion:characters["profryder"].standingLookingTest},
  {text:"Oh, you’ve got a lot of mistakes here...", emotion:characters["profryder"].standingNeutralTest},
  {text:"Don’t worry, that’s only the start of the course", emotion:characters["profryder"].standingSmilingTest},
  {text:"But be more careful next time", emotion:characters["profryder"].standingNeutralTest},
  {text:"And don’t be afraid to ask any questions!", emotion:characters["profryder"].standingSmilingTest},
]
},
],
answeredSpecialQuestion:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Oh yeah, and thank you for answering the extra question...", emotion:characters["profryder"].standingLookingTest},
    {text:"It’ll help us A LOT... With the research, I mean...", emotion:characters["profryder"].standingLookingTest},
  ]
  }
],
answeredSpecialQuestionAroused:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Oh yeah, and thank you for answering the extra question...", emotion:characters["profryder"].standingCheckingTestAroused},
    {text:"It’ll help us A LOT... With the research, I mean...", emotion:characters["profryder"].standingCheckingTestAroused},
  ]
  }
],
endingAroused:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"You can go back to your seat, the practice starts soon!", emotion:characters["profryder"].laughingTestAroused},
  ]
},
{endOfNovel:true}
],
ending:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"You can go back to your seat, the practice starts soon!", emotion:characters["profryder"].standingSmilingTest},
  ]
},
{endOfNovel:true}
]},

{novel:true, background:classroomTables_bg, startCoordinates:50,
script:[
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:3, transitionMode: "slow",
  phrases:[
    {text:"You finished?", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"What’s in that last one? I don’t really know anything about.. guy stuff", emotion:characters["phoebe"].sittingQuestionCoffee, answers:["Prostate","Penile glans","Testicles"]},
  ]
},

//Prostate
{option:"Prostate", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Okay", emotion:characters["phoebe"].sittingSmilingCoffee, achievement:achievements[6]},
]
},
{option:"Prostate", endOfOption:true},

//Penile glans
{option:"Penile glans", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Okay", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{option:"Penile glans", endOfOption:true},

//Testicles
{option:"Testicles", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Okay", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{option:"Testicles", endOfOption:true, endOfOptions:true},

{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Thanks!", emotion:characters["phoebe"].sittingSmilingCoffee},
  {text:"Here", emotion:characters["phoebe"].sittingSmilingCoffee},
  {item:sheet, open:true},
  {text:"If you’re really interested", emotion:characters["phoebe"].sittingSmilingCoffee},
  {item:sheet, close:true},
  {text:"...", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{char:characters["willie"],  position:"right",  coordinates: 20, speed:1,
phrases:[
  {text:"Oh, dude, let me see!", emotion:characters["willie"].sittingSurprised},
  {text:"I wish they had these pussy burger set in McDonalds...", emotion:characters["willie"].sittingSnide},
  {text:"I’d eat them all...", emotion:characters["willie"].sittingSnide},
]
},
{endOfNovel:true}
]},

{blackScreen:true, txt:["<h2>It's the end of the first chapter! I hope you enjoyed it! </h2> <br/> Feel free to share your thoughts in comments;)","<h2>Chapter Two(Practicing) is already available on my Patreon, along with updates on what’s coming next, WIPs, feedback polls, and exclusive content!</h2> <br> You can check out its trailer below 👇","<h2>Your support means a lot — it would really help me keep improving the game and creating more content! </br> Thank you!💖</h2>"], trailer:true, end:true},


  /*
  {novel:true, background:hall_bg,
  script:[
  {char:characters["phoebe"],  position:"left", startCoordinates:-50, coordinates: 0, speed:0.5,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {item:sheet, open:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
    {item:sheet, close:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral, achievement:achievements[2]},
  ]
  },
 {
  char:characters["phoebe2"],  position:"left", coordinates: 1, speed:1,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  ]
  },
  {scene:true, img:hall_bg, start:true},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
  ]},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
      {text:"??", answers:["yay", "nay", "lol"]}
  ]},
  {option:"yay", start:true},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"??"}
  ]},
  {option:"yay", endOfOption:true},
  {option:"nay", start:true},

  {option:"nay", endOfOption:true, endOfOptions:true},
  {scene:true, endOfScene:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1,
 phrases:[
  {text:"Lorem ipsum dolor sit amet22", emotion:characters["phoebe"].laughing},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
  {text:"??", answers:["yay", "nay", "lol"], emotion:characters["phoebe"].smile}
 ]
 },
 {option:"yay", start:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1.2,
 phrases:[
  {text:"u chose yay option", emotion:characters["phoebe"].laughing, animation:true, achievement:achievements[0]},
  {text:"u chose yay option", emotion:characters["phoebe"].smile},
 ]
 },
 {option:"yay", endOfOption:true},

 {option:"nay", start:true},
 {char:characters["phoebe"],  position:"right", coordinates: -50, speed:1,
 phrases:[
  {text:"u chose nay option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"nay", endOfOption:true},

 {option:"lol", start:true},
 {char:characters["phoebe"],  position:"left", coordinates: -50, speed:1.2,
 phrases:[
  {text:"u chose lol option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"lol", endOfOption:true, endOfOptions:true},

 {
 char:characters["phoebe"],  position:"left", coordinates: 0, speed:1.2,
 phrases:[
  {text:"endgf", emotion:characters["phoebe"].smile}
 ]
 }
]
},
*/

];

export default chapter1;
